import { enablePointerEvents } from '@utils/pointer-events-control';
// Sharing Is Caring – ported from legacy demo (Phaser via CDN) to webpack/ESM.

let xPos = 410;
let yPos = 300;
let poppins = [[], [], [], [], [], [], []]; // 2-d snack grid
let accumulator1 = [];
let accumulator2 = [];
let accumulator3 = [];
let accumulator4 = [];
let accumulator5 = [];
let accumulator6 = [];
let accumulator7 = [];
let accumulator8 = [];
let accumulator9 = [];
let delaying = 50;
let round = 1;
let firstInput = false;
let row = 7;
let col = 9;
let x;
let y;
let entry = 0;
let wrong = 0;
let wrongEffect = 0;
let call = 0;
let correctEffect = 0;
let target1 = 0;
let target2 = 0;
let target3 = 0;
let target4 = 0;
let target5 = 0;
let target6 = 0;
let target7 = 0;
let target8 = 0;
let groupCount = 0;
let correctTarget1 = 0;
let correctTarget2 = 0;
let correctTarget3 = 0;
let correctTarget4 = 0;
let correctTarget5 = 0;
let correctTarget6 = 0;
let correctTarget7 = 0;
let correctTarget8 = 0;
let tick = 0;
let tickStore = [];
let k;
let t;
let e;
let f;
let g;
let u;
let v;
let o;
let imageSet = [];
let finalImage = [];
let rowPos;
let colPos;

export default class GameScene extends Phaser.Scene {
  constructor() {
    super({ key: 'GameScene' });
  }

  create() {
    // Enable pointer events so hover states and the cursor work
    enablePointerEvents();

    // Reset module-scope state on every (re)entry to avoid stale values after replay
    this._resetGlobals();

    const cam = this.cameras.main;
    cam.fadeIn(100, 255, 255, 255);

    this.BG = this.add.image(cam.width / 2, cam.height / 2, 'gameBG');
    this.snackbar = this.add.image(55, 180, 'snackbar');
    this.smallBlue = this.add.image(56, 54, 'smallBlue').setScale(1.1);
    this.smallPurple = this.add.image(56, 104, 'smallPurple').setScale(1.1);
    this.smallYellow = this.add.image(56, 155, 'smallYellow').setScale(1.1);
    this.smallGreen = this.add.image(56, 205, 'smallGreen').setScale(1.1);
    this.smallPink = this.add.image(56, 256, 'smallPink').setScale(1.1);
    this.smallGreen2 = this.add.image(56, 307, 'smallLightGreen').setScale(1.1);
    this.barContainer = this.add.container(0, 0, [
      this.snackbar,
      this.smallBlue,
      this.smallPurple,
      this.smallYellow,
      this.smallGreen,
      this.smallPink,
      this.smallGreen2,
    ]);

    this.notepad = this.add.image(550, 120, 'notepad');
    this.pencil = this.add.image(1110, 600, 'pencil');
    this.dividendHundredth = this.add
      .text(370, 97, '', { fontFamily: 'font2', fontSize: '52px', fill: '#2B2B2B' })
      .setAlpha(0)
      .setResolution(1.0);
    this.dividendTenth = this.add
      .text(380, 97, '6', { fontFamily: 'font2', fontSize: '52px', fill: '#2B2B2B' })
      .setAlpha(0)
      .setResolution(1.0);
    this.dividendUnit = this.add
      .text(430, 97, '3', { fontFamily: 'font2', fontSize: '52px', fill: '#2B2B2B' })
      .setAlpha(0)
      .setResolution(1.0);
    this.divisor = this.add
      .text(510, 97, '3', { fontFamily: 'font2', fontSize: '52px', fill: '#2B2B2B' })
      .setAlpha(0)
      .setResolution(1.0);

    this.input1 = this.add.image(629, 123, 'default').setScale(0.5);
    this.input2 = this.add.image(688, 123, 'default').setScale(0.5);
    this.inputTextTenth = this.add
      .text(250, 100, '', { fontFamily: 'font2', fontSize: '45px', fill: '#2B2B2B' })
      .setResolution(1.0);
    this.inputTextUnit = this.add
      .text(300, 100, '', { fontFamily: 'font2', fontSize: '45px', fill: '#2B2B2B' })
      .setResolution(1.0);
    this.cursorTenth = this.add.image(630, 110, 'cursor').setOrigin(0).setVisible(false);
    this.cursorUnit = this.add.image(688, 110, 'cursor').setOrigin(0).setVisible(false);
    this.confirm = this.add.image(880, 120, 'confirm').setAlpha(0);

    this.anims.create({
      key: 'confetti',
      frames: this.anims.generateFrameNames('confetti', {
        start: 0,
        end: 81,
        zeroPad: 0,
        prefix: 'confetti',
        suffix: '.png',
      }),
      frameRate: 35,
      repeat: 0,
    });

    this.anims.create({
      key: 'tick',
      frames: this.anims.generateFrameNames('tick', {
        start: 0,
        end: 19,
        zeroPad: 0,
        prefix: 'tick',
        suffix: '.png',
      }),
      frameRate: 20,
      repeat: 0,
    });

    this.candiesAppear = this.sound.add('candiesAppear');
    this.correctAnswers = this.sound.add('correctAnswers');
    this.incorrectAnswers = this.sound.add('incorrectAnswers');
    this.candiesGrouping = this.sound.add('candiesGrouping');
    this.bowlappear = this.sound.add('bowlAppear');

    // Round-1 blue toffees creation
    for (let i = 0; i < 7; i++) {
      for (let j = 0; j < 9; j++) {
        poppins[i][j] = this.add.image(xPos, yPos, 'blue').setScale(0);
        xPos += 55;
      }
      xPos = 410;
      yPos += 45;
    }

    this.time.delayedCall(400, () => {
      this.candiesAppear.setVolume(0.1).play();

      // Round-1 Blue Toffees appearance tween effect
      for (let i = 0; i < 7; i++) {
        this.scales = this.tweens.add({
          targets: poppins[i],
          scale: 1.2,
          duration: 350,
          delay: delaying,
          ease: 'Power1',
          repeat: 0,
          yoyo: false,
        });

        this.scales.on('complete', () => {
          this.tweens.add({
            targets: poppins[i],
            scale: 1,
            duration: 0,
            delay: 0,
            ease: 'Power1',
            repeat: 0,
            yoyo: false,
          });
        });
        delaying += 100;
      }

      this.time.delayedCall(1300, () => {
        this.tweens.add({
          targets: [this.dividendTenth, this.dividendUnit, this.divisor],
          alpha: 1,
          duration: 250,
          delay: 25,
          ease: 'Power1',
          repeat: 0,
          yoyo: false,
        });
        this.input1.setInteractive({ cursor: 'pointer' });
        this.input2.setInteractive({ cursor: 'pointer' });
      });
    });

    this.input1.on('pointerup', () => {
      this.input.keyboard.enabled = true;
      entry = 1;
      wrongEffect = 0;
      correctEffect = 0;
      this.cursorTenth.setAlpha(1);
      this.cursorUnit.setAlpha(1);
      if (round > 1) {
        this.containerNotepad.setDepth(1);
        this.cursorTenth.setDepth(2);
        this.cursorUnit.setDepth(2);
      }
      this._startCursorFlash(this.cursorTenth);

      this.input1.setTexture('typing');
      this.input2.setTexture('default');
      this.cursorTenth.setVisible(true);
      this.cursorUnit.setVisible(false);
    });

    this.input2.on('pointerup', () => {
      this.input.keyboard.enabled = true;
      entry = 2;
      wrongEffect = 0;
      correctEffect = 0;
      this.cursorTenth.setAlpha(1);
      this.cursorUnit.setAlpha(1);
      if (round > 1) {
        this.containerNotepad.setDepth(1);
        this.cursorTenth.setDepth(2);
        this.cursorUnit.setDepth(2);
      }
      this._startCursorFlash(this.cursorUnit);

      this.input1.setTexture('default');
      this.input2.setTexture('typing');
      this.cursorUnit.setVisible(true);
      this.cursorTenth.setVisible(false);
    });

    this.input.keyboard.on('keydown', event => {
      this.inputTextUnit.setFill('#2B2B2B');
      this.inputTextTenth.setFill('#2B2B2B');
      // confirm appears after 1st input
      firstInput = true;
      if (firstInput == true) this.confirmAppear();

      if (entry == 1) {
        x = parseInt(event.key);
        if (round < 3) {
          if (x == 0 || (x >= 2 && x <= 9)) this.inputTextTenth.x = 617;
          if (x == 1) this.inputTextTenth.x = 621;
        }
        if (round >= 3) {
          if (x == 0 || (x >= 2 && x <= 9)) this.inputTextTenth.x = 629;
          if (x == 1) this.inputTextTenth.x = 635;
        }
        this.inputTextTenth.setText(x);
      }

      if (entry == 2) {
        y = parseInt(event.key);
        if (round < 3) {
          if (y == 0 || (y >= 2 && y <= 9)) this.inputTextUnit.x = 675;
          if (y == 1) this.inputTextUnit.x = 680;
        }
        if (round >= 3) {
          if (y == 0 || (y >= 2 && y <= 9)) this.inputTextUnit.x = 689;
          if (y == 1) this.inputTextUnit.x = 694;
        }
        this.inputTextUnit.setText(y);
      }

      wrong = x * 10 + y;

      if (
        this.inputTextUnit.text.length > 0 &&
        this.inputTextTenth.text.length > 0 &&
        this.inputTextTenth.text != '0'
      ) {
        this.confirm.setInteractive({ cursor: 'pointer' });
      } else if (this.inputTextTenth.text == '0') {
        this.confirm.disableInteractive();
      } else {
        this.confirm.disableInteractive();
      }
    });

    this.confirm.on('pointerover', () => this.confirm.setTexture('confirmBlack'));
    this.confirm.on('pointerout', () => this.confirm.setTexture('confirm'));

    this.confirm.on('pointerdown', () => {
      if (round == 1) {
        if (this.inputTextUnit.text == '1' && this.inputTextTenth.text == '2') {
          this.correctAnswer(7, 3);
        }
        if (
          (this.inputTextUnit.text == '1' && this.inputTextTenth.text != '2') ||
          (this.inputTextUnit.text != '1' && this.inputTextTenth.text == '2') ||
          (this.inputTextUnit.text != '1' && this.inputTextTenth.text != '2')
        ) {
          this.wrongAnswer(row, col);
        }
      }

      if (round == 2 || round == 3) {
        if (this.inputTextUnit.text == '8' && this.inputTextTenth.text == '1') {
          this.correctAnswer(9, 2);
        }
        if (
          (this.inputTextUnit.text == '8' && this.inputTextTenth.text != '1') ||
          (this.inputTextUnit.text != '8' && this.inputTextTenth.text == '1') ||
          (this.inputTextUnit.text != '8' && this.inputTextTenth.text != '1')
        ) {
          this.wrongAnswer(row, col);
        }
      }

      if (round == 4) {
        if (this.inputTextUnit.text == '4' && this.inputTextTenth.text == '1') {
          this.correctAnswer(7, 2);
        }
        if (
          (this.inputTextUnit.text == '4' && this.inputTextTenth.text != '1') ||
          (this.inputTextUnit.text != '4' && this.inputTextTenth.text == '1') ||
          (this.inputTextUnit.text != '4' && this.inputTextTenth.text != '1')
        ) {
          this.wrongAnswer(row, col);
        }
      }

      if (round == 5) {
        if (this.inputTextUnit.text == '7' && this.inputTextTenth.text == '1') {
          this.correctAnswer(row, col);
        }
        if (
          (this.inputTextUnit.text == '7' && this.inputTextTenth.text != '1') ||
          (this.inputTextUnit.text != '7' && this.inputTextTenth.text == '1') ||
          (this.inputTextUnit.text != '7' && this.inputTextTenth.text != '1')
        ) {
          this.wrongAnswer(row, col);
        }
      }

      if (round == 6) {
        if (this.inputTextUnit.text == '4' && this.inputTextTenth.text == '2') {
          this.correctAnswer(12, 2);
        }
        if (
          (this.inputTextUnit.text == '4' && this.inputTextTenth.text != '2') ||
          (this.inputTextUnit.text != '4' && this.inputTextTenth.text == '2') ||
          (this.inputTextUnit.text != '4' && this.inputTextTenth.text != '2')
        ) {
          this.wrongAnswer(row, col);
        }
      }
    });
  } // create()

  // Reset all module-scope variables to initial values (used on scene re-entry).
  _resetGlobals() {
    xPos = 410;
    yPos = 300;
    poppins = [[], [], [], [], [], [], []];
    accumulator1 = [];
    accumulator2 = [];
    accumulator3 = [];
    accumulator4 = [];
    accumulator5 = [];
    accumulator6 = [];
    accumulator7 = [];
    accumulator8 = [];
    accumulator9 = [];
    delaying = 50;
    round = 1;
    firstInput = false;
    row = 7;
    col = 9;
    entry = 0;
    wrong = 0;
    wrongEffect = 0;
    call = 0;
    correctEffect = 0;
    target1 = target2 = target3 = target4 = 0;
    target5 = target6 = target7 = target8 = 0;
    groupCount = 0;
    correctTarget1 = correctTarget2 = correctTarget3 = correctTarget4 = 0;
    correctTarget5 = correctTarget6 = correctTarget7 = correctTarget8 = 0;
    tick = 0;
    tickStore = [];
    imageSet = [];
    finalImage = [];
  }

  // Replacement for rex flash plugin: alpha-tween a cursor.
  _startCursorFlash(target) {
    if (this._cursorFlashTween) this._cursorFlashTween.stop();
    target.setAlpha(1);
    this._cursorFlashTween = this.tweens.add({
      targets: target,
      alpha: 0,
      duration: 350,
      yoyo: true,
      repeat: -1,
    });
  }

  confirmAppear() {
    this.tweens.add({
      targets: this.confirm,
      alpha: 1,
      duration: 250,
      delay: 25,
      ease: 'Power1',
      repeat: 0,
      yoyo: false,
    });
    firstInput = false;
  }

  correctAnswer(r, c) {
    accumulator1 = [];
    accumulator2 = [];
    accumulator3 = [];
    accumulator4 = [];
    accumulator5 = [];
    accumulator6 = [];
    accumulator7 = [];
    accumulator8 = [];
    accumulator9 = [];

    this.container1 = this.add.container(0, 0, []);
    this.container2 = this.add.container(0, 0, []);
    this.container3 = this.add.container(0, 0, []);
    if (round >= 2) this.container4 = this.add.container(0, 0, []);
    if (round >= 3) {
      this.container5 = this.add.container(0, 0, []);
      this.container6 = this.add.container(0, 0, []);
    }
    if (round >= 4) {
      this.container7 = this.add.container(0, 0, []);
      this.container8 = this.add.container(0, 0, []);
    }
    if (round == 5) this.container9 = this.add.container(0, 0, []);

    if (round != 5) {
      for (let i = 0; i < r; i++) {
        for (let j = 0; j < c; j++) {
          this.container1.add(poppins[i][j]);
          accumulator1.push(poppins[i][j]);
        }
      }
    }

    let up1;
    for (let i = 0; i < r; i++) {
      if (round == 1) up1 = c + 3;
      if (round == 2 || round == 3 || round == 4 || round == 6) up1 = c + 2;
      for (let j = c; j < up1; j++) {
        this.container2.add(poppins[i][j]);
        accumulator2.push(poppins[i][j]);
      }
    }
    let up2;
    for (let i = 0; i < r; i++) {
      if (round == 1) up2 = c + 6;
      if (round == 2 || round == 3 || round == 4 || round == 6) up2 = c + 4;
      for (let j = up1; j < up2; j++) {
        this.container3.add(poppins[i][j]);
        accumulator3.push(poppins[i][j]);
      }
    }

    let up3;
    let up4;
    let up5;
    if ((round >= 2 && round <= 4) || round == 6) {
      for (let i = 0; i < r; i++) {
        if (round == 2 || round == 3 || round == 4 || round == 6) up3 = c + 6;
        for (let j = up2; j < up3; j++) {
          this.container4.add(poppins[i][j]);
          accumulator4.push(poppins[i][j]);
        }
      }
      for (let i = 0; i < r; i++) {
        if (round == 3 || round == 4 || round == 6) up4 = c + 8;
        for (let j = up3; j < up4; j++) {
          this.container5.add(poppins[i][j]);
          accumulator5.push(poppins[i][j]);
        }
      }
      for (let i = 0; i < r; i++) {
        if (round == 3 || round == 4 || round == 6) up5 = c + 10;
        for (let j = up4; j < up5; j++) {
          this.container6.add(poppins[i][j]);
          accumulator6.push(poppins[i][j]);
        }
      }
    }

    if (round == 4 || round == 6) {
      let up6;
      for (let i = 0; i < r; i++) {
        up6 = c + 12;
        for (let j = up5; j < up6; j++) {
          this.container7.add(poppins[i][j]);
          accumulator7.push(poppins[i][j]);
        }
      }
      let up7;
      for (let i = 0; i < r; i++) {
        up7 = c + 14;
        for (let j = up6; j < up7; j++) {
          this.container8.add(poppins[i][j]);
          accumulator8.push(poppins[i][j]);
        }
      }
    }

    if (round == 5) {
      let p;
      let q;
      let a;
      let b;
      let m;
      let n;
      let cVar;
      let d;
      let kVar;
      let l;
      let s;
      let rVar;
      let h;
      let z;
      let yVar;
      let w;

      start1: for (p = 0; p < col; p++) {
        for (q = 0; q < row; q++) {
          this.container1.add(poppins[q][p]);
          accumulator1.push(poppins[q][p]);
          correctTarget1++;
          if (correctTarget1 == 17) {
            q++;
            break start1;
          }
        }
      }
      let kk;
      start2: for (a = p; a < col; a++) {
        if (a != p) kk = 0;
        else kk = q;
        for (b = kk; b < row; b++) {
          this.container2.add(poppins[b][a]);
          accumulator2.push(poppins[b][a]);
          correctTarget2++;
          if (correctTarget2 == 17) {
            b++;
            break start2;
          }
        }
      }
      let ee;
      start3: for (m = a; m < col; m++) {
        if (m != a) ee = 0;
        else ee = b;
        for (n = ee; n < row; n++) {
          this.container3.add(poppins[n][m]);
          accumulator3.push(poppins[n][m]);
          correctTarget3++;
          if (correctTarget3 == 17) {
            n++;
            break start3;
          }
        }
      }
      let tt;
      start4: for (cVar = m; cVar < col; cVar++) {
        if (cVar != m) tt = 0;
        else tt = n;
        for (d = tt; d < row; d++) {
          this.container4.add(poppins[d][cVar]);
          accumulator4.push(poppins[d][cVar]);
          correctTarget4++;
          if (correctTarget4 == 17) {
            d++;
            break start4;
          }
        }
      }
      let ff;
      start5: for (kVar = cVar; kVar < col; kVar++) {
        if (kVar != cVar) ff = 0;
        else ff = d;
        for (l = ff; l < row; l++) {
          this.container5.add(poppins[l][kVar]);
          accumulator5.push(poppins[l][kVar]);
          correctTarget5++;
          if (correctTarget5 == 17) {
            l++;
            break start5;
          }
        }
      }
      let gg;
      start6: for (s = kVar; s < col; s++) {
        if (s != kVar) gg = 0;
        else gg = l;
        for (rVar = gg; rVar < row; rVar++) {
          this.container6.add(poppins[rVar][s]);
          accumulator6.push(poppins[rVar][s]);
          correctTarget6++;
          if (correctTarget6 == 17) {
            rVar++;
            break start6;
          }
        }
      }
      let uu;
      start7: for (h = s; h < col; h++) {
        if (h != s) uu = 0;
        else uu = rVar;
        for (z = uu; z < row; z++) {
          this.container7.add(poppins[z][h]);
          accumulator7.push(poppins[z][h]);
          correctTarget7++;
          if (correctTarget7 == 17) {
            z++;
            break start7;
          }
        }
      }
      let vv;
      start8: for (yVar = h; yVar < col; yVar++) {
        if (yVar != h) vv = 0;
        else vv = z;
        for (w = vv; w < row; w++) {
          this.container8.add(poppins[w][yVar]);
          accumulator8.push(poppins[w][yVar]);
          correctTarget8++;
          if (correctTarget8 == wrong) {
            w++;
            break start8;
          }
        }
      }
      let ss;
      for (let i = yVar; i < col; i++) {
        if (i != yVar) ss = 0;
        else ss = w;
        for (let j = ss; j < row; j++) {
          this.container9.add(poppins[j][i]);
          accumulator9.push(poppins[j][i]);
        }
      }
    }

    this.correctEffects();
  }

  wrongAnswer(_rArg, _cArg) {
    this.container9 = this.add.container(0, 0, []);
    this.container10 = this.add.container(0, 0, []);
    this.container11 = this.add.container(0, 0, []);
    if (round >= 2) this.container12 = this.add.container(0, 0, []);
    if (round >= 3) {
      this.container13 = this.add.container(0, 0, []);
      this.container14 = this.add.container(0, 0, []);
    }
    if (round >= 4) {
      this.container15 = this.add.container(0, 0, []);
      this.container16 = this.add.container(0, 0, []);
    }
    if (round == 5) this.container17 = this.add.container(0, 0, []);

    k = 0;
    t = 0;
    e = 0;
    f = 0;
    g = 0;
    u = 0;
    v = 0;
    target1 = 0;
    target2 = 0;
    target3 = 0;
    target4 = 0;
    target5 = 0;
    target6 = 0;
    target7 = 0;
    target8 = 0;
    groupCount = 0;
    finalImage = [];
    rowPos = 0;
    colPos = 0;

    let p;
    let q;
    let a;
    let b;
    let m;
    let n;
    let cVar;
    let d;
    let kVar;
    let l;
    let s;
    let rVar;
    let h;
    let z;
    let yVar;
    let w;

    start: for (p = 0; p < col; p++) {
      for (q = 0; q < row; q++) {
        this.container9.add(poppins[q][p]);
        target1++;
        if (target1 == wrong) {
          q++;
          if (round == 5 || round == 6) {
            rowPos = q;
            colPos = p;
            this.imageStore();
          }
          break start;
        }
      }
    }

    first: for (a = p; a < col; a++) {
      if (a != p) k = 0;
      else k = q;
      for (b = k; b < row; b++) {
        this.container10.add(poppins[b][a]);
        target2++;
        if (target2 == wrong) {
          b++;
          if (round == 5 || round == 6) {
            rowPos = b;
            colPos = a;
            this.imageStore();
          }
          break first;
        }
      }
    }

    out: for (m = a; m < col; m++) {
      if (m != a) e = 0;
      else e = b;
      for (n = e; n < row; n++) {
        this.container11.add(poppins[n][m]);
        if (round >= 2) {
          target3++;
          if (target3 == wrong) {
            n++;
            if (round == 5 || round == 6) {
              rowPos = n;
              colPos = m;
              this.imageStore();
            }
            break out;
          }
        }
      }
    }

    if (round >= 2) {
      outer: for (cVar = m; cVar < col; cVar++) {
        if (cVar != m) t = 0;
        else t = n;
        for (d = t; d < row; d++) {
          this.container12.add(poppins[d][cVar]);
          if (round >= 3) {
            target4++;
            if (target4 == wrong) {
              d++;
              if (round == 5 || round == 6) {
                rowPos = d;
                colPos = cVar;
                this.imageStore();
              }
              break outer;
            }
          }
        }
      }
    }

    if (round >= 3) {
      up: for (kVar = cVar; kVar < col; kVar++) {
        if (kVar != cVar) f = 0;
        else f = d;
        for (l = f; l < row; l++) {
          this.container13.add(poppins[l][kVar]);
          target5++;
          if (target5 == wrong) {
            l++;
            if (round == 5 || round == 6) {
              rowPos = l;
              colPos = kVar;
              this.imageStore();
            }
            break up;
          }
        }
      }
      come: for (s = kVar; s < col; s++) {
        if (s != kVar) g = 0;
        else g = l;
        for (rVar = g; rVar < row; rVar++) {
          this.container14.add(poppins[rVar][s]);
          if (round >= 4) {
            target6++;
            if (target6 == wrong) {
              rVar++;
              if (round == 5 || round == 6) {
                rowPos = rVar;
                colPos = s;
                this.imageStore();
              }
              break come;
            }
          }
        }
      }
    }

    if (round >= 4) {
      begin: for (h = s; h < col; h++) {
        if (h != s) u = 0;
        else u = rVar;
        for (z = u; z < row; z++) {
          this.container15.add(poppins[z][h]);
          target7++;
          if (target7 == wrong) {
            z++;
            if (round == 5 || round == 6) {
              rowPos = z;
              colPos = h;
              this.imageStore();
            }
            break begin;
          }
        }
      }

      yes: for (yVar = h; yVar < col; yVar++) {
        if (yVar != h) v = 0;
        else v = z;
        for (w = v; w < row; w++) {
          this.container16.add(poppins[w][yVar]);
          if (round == 5) {
            target8++;
            if (target8 == wrong) {
              w++;
              if (round == 5) {
                rowPos = w;
                colPos = yVar;
                this.imageStore();
              }
              break yes;
            }
          }
        }
      }
    }

    if (round == 5) {
      for (let ij = yVar; ij < col; ij++) {
        if (ij != yVar) o = 0;
        else o = w;
        for (let pq = o; pq < row; pq++) this.container17.add(poppins[pq][ij]);
      }
    }

    // Group counts per round
    if (round == 1) {
      if (wrong <= 31) groupCount = 3;
      else if (wrong <= 62) groupCount = 2;
      else groupCount = 1;
    }
    if (round == 2) {
      if (wrong <= 23) groupCount = 4;
      else if (wrong <= 35) groupCount = 3;
      else if (wrong <= 71) groupCount = 2;
      else groupCount = 1;
    }
    if (round == 3) {
      if (wrong <= 21) groupCount = 6;
      else if (wrong <= 26) groupCount = 5;
      else if (wrong <= 35) groupCount = 4;
      else if (wrong <= 53) groupCount = 3;
      else if (wrong <= 107) groupCount = 2;
      else groupCount = 1;
    }
    if (round == 4) {
      if (wrong <= 15) groupCount = 8;
      else if (wrong <= 18) groupCount = 7;
      else if (wrong <= 22) groupCount = 6;
      else if (wrong <= 27) groupCount = 5;
      else if (wrong <= 37) groupCount = 4;
      else if (wrong <= 55) groupCount = 3;
      else if (wrong <= 111) groupCount = 2;
      else groupCount = 1;
    }
    if (round == 5) {
      if (wrong <= 19) groupCount = 9;
      else if (wrong <= 21) groupCount = 8;
      else if (wrong <= 25) groupCount = 7;
      else if (wrong <= 30) groupCount = 6;
      else if (wrong <= 38) groupCount = 5;
      else if (wrong <= 50) groupCount = 4;
      else if (wrong <= 76) groupCount = 3;
      else if (wrong <= 152) groupCount = 2;
      else groupCount = 1;
    }
    if (round == 6) {
      if (wrong <= 27) groupCount = 8;
      else if (wrong <= 32) groupCount = 7;
      else if (wrong <= 38) groupCount = 6;
      else if (wrong <= 48) groupCount = 5;
      else if (wrong <= 63) groupCount = 4;
      else if (wrong <= 96) groupCount = 3;
      else if (wrong <= 192) groupCount = 2;
      else groupCount = 1;
    }

    // Wrong group displacement
    if (round == 1) {
      if (groupCount == 3) {
        this.wrongGroupMove(this.container9, -70);
        this.wrongGroupMove(this.container10, 0);
        this.wrongGroupMove(this.container11, 70);
      }
      if (groupCount == 2) {
        this.wrongGroupMove(this.container9, -70);
        this.wrongGroupMove(this.container10, 70);
      }
    }
    if (round == 2) {
      if (groupCount == 4) {
        this.wrongGroupMove(this.container12, 140);
        this.wrongGroupMove(this.container11, 70);
        this.wrongGroupMove(this.container10, 0);
        this.wrongGroupMove(this.container9, -70);
      }
      if (groupCount == 3) {
        this.wrongGroupMove(this.container11, 100);
        this.wrongGroupMove(this.container10, 0);
        this.wrongGroupMove(this.container9, -100);
      }
      if (groupCount == 2) {
        this.wrongGroupMove(this.container10, 70);
        this.wrongGroupMove(this.container9, -70);
      }
    }
    if (round == 3) {
      if (groupCount == 6) {
        this.wrongGroupMove(this.container9, -150);
        this.wrongGroupMove(this.container10, -100);
        this.wrongGroupMove(this.container11, -50);
        this.wrongGroupMove(this.container12, 0);
        this.wrongGroupMove(this.container13, 50);
        this.wrongGroupMove(this.container14, 100);
      }
      if (groupCount == 5) {
        this.wrongGroupMove(this.container9, -140);
        this.wrongGroupMove(this.container10, -70);
        this.wrongGroupMove(this.container11, 0);
        this.wrongGroupMove(this.container12, 70);
        this.wrongGroupMove(this.container13, 140);
      }
      if (groupCount == 4) {
        this.wrongGroupMove(this.container9, -140);
        this.wrongGroupMove(this.container10, -70);
        this.wrongGroupMove(this.container11, 0);
        this.wrongGroupMove(this.container12, 70);
      }
      if (groupCount == 3) {
        this.wrongGroupMove(this.container9, -60);
        this.wrongGroupMove(this.container10, 0);
        this.wrongGroupMove(this.container11, 60);
      }
      if (groupCount == 2) {
        this.wrongGroupMove(this.container9, -50);
        this.wrongGroupMove(this.container10, 50);
      }
    }
    if (round == 4 || round == 6 || (round == 5 && groupCount < 9)) {
      if (groupCount == 8) {
        this.wrongGroupMove(this.container9, -160);
        this.wrongGroupMove(this.container10, -120);
        this.wrongGroupMove(this.container11, -80);
        this.wrongGroupMove(this.container12, -40);
        this.wrongGroupMove(this.container13, 0);
        this.wrongGroupMove(this.container14, 40);
        this.wrongGroupMove(this.container15, 80);
        this.wrongGroupMove(this.container16, 120);
      }
      if (groupCount == 7) {
        this.wrongGroupMove(this.container9, -150);
        this.wrongGroupMove(this.container10, -100);
        this.wrongGroupMove(this.container11, -50);
        this.wrongGroupMove(this.container12, 0);
        this.wrongGroupMove(this.container13, 50);
        this.wrongGroupMove(this.container14, 100);
        this.wrongGroupMove(this.container15, 150);
      }
      if (groupCount == 6) {
        this.wrongGroupMove(this.container9, -150);
        this.wrongGroupMove(this.container10, -100);
        this.wrongGroupMove(this.container11, -50);
        this.wrongGroupMove(this.container12, 0);
        this.wrongGroupMove(this.container13, 50);
        this.wrongGroupMove(this.container14, 100);
      }
      if (groupCount == 5) {
        this.wrongGroupMove(this.container9, -140);
        this.wrongGroupMove(this.container10, -70);
        this.wrongGroupMove(this.container11, 0);
        this.wrongGroupMove(this.container12, 70);
        this.wrongGroupMove(this.container13, 140);
      }
      if (groupCount == 4) {
        this.wrongGroupMove(this.container9, -140);
        this.wrongGroupMove(this.container10, -70);
        this.wrongGroupMove(this.container11, 0);
        this.wrongGroupMove(this.container12, 70);
      }
      if (groupCount == 3) {
        this.wrongGroupMove(this.container9, -100);
        this.wrongGroupMove(this.container10, 0);
        this.wrongGroupMove(this.container11, 100);
      }
      if (groupCount == 2) {
        this.wrongGroupMove(this.container9, -50);
        this.wrongGroupMove(this.container10, 50);
      }
    }
    if (round == 5 && groupCount == 9) {
      this.wrongGroupMove(this.container9, -200);
      this.wrongGroupMove(this.container10, -150);
      this.wrongGroupMove(this.container11, -100);
      this.wrongGroupMove(this.container12, -50);
      this.wrongGroupMove(this.container13, 0);
      this.wrongGroupMove(this.container14, 50);
      this.wrongGroupMove(this.container15, 100);
      this.wrongGroupMove(this.container16, 150);
      this.wrongGroupMove(this.container17, 200);
    }

    this.wrongEffect();

    this.time.delayedCall(3000, () => {
      // Bring all wrong groups back to original position
      const movables = [this.container9, this.container10, this.container11];
      if (round >= 2) movables.push(this.container12);
      if (round >= 3) movables.push(this.container13, this.container14);
      if (round >= 4) movables.push(this.container15, this.container16);
      if (round == 5) movables.push(this.container17);
      movables.forEach(c => {
        this.tweens.add({
          targets: c,
          x: 0,
          duration: 500,
          delay: 50,
          ease: 'Power1',
          yoyo: false,
        });
      });

      this.time.delayedCall(500, () => {
        this.container9.destroy();
        this.container10.destroy();
        this.container11.destroy();
        if (round >= 2) this.container12.destroy();
        if (round >= 3) {
          this.container13.destroy();
          this.container14.destroy();
        }
        if (round >= 4) {
          this.container15.destroy();
          this.container16.destroy();
        }
        if (round == 5) this.container17.destroy();

        let object;
        if (round == 1) {
          xPos = 410;
          yPos = 300;
          object = 'blue';
        }
        if (round == 2) {
          xPos = 430;
          yPos = 280;
          object = 'purple';
        }
        if (round == 3) {
          xPos = 375;
          yPos = 270;
          object = 'yellow';
        }
        if (round == 4) {
          xPos = 375;
          yPos = 310;
          object = 'green';
        }
        if (round == 5) {
          xPos = 365;
          yPos = 290;
          object = imageSet[0][0];
        }
        if (round == 6) {
          xPos = 365;
          yPos = 290;
          object = imageSet[0][0];
        }

        for (let i = 0; i < row; i++) {
          for (let j = 0; j < col; j++) {
            if (round == 5 || round == 6) object = imageSet[i][j];
            if (round <= 3) poppins[i][j] = this.add.image(xPos, yPos, object);
            if (round == 4 || round == 5)
              poppins[i][j] = this.add.image(xPos, yPos, object).setScale(0.9);
            if (round == 6)
              poppins[i][j] = this.add.image(xPos, yPos, object).setScale(0.8);
            if (round == 1 || round == 2) xPos += 55;
            if (round == 3) xPos += 53;
            if (round == 4) xPos += 38;
            if (round == 5) xPos += 37;
            if (round == 6) xPos += 37;
          }
          if (round == 1) xPos = 410;
          if (round == 2) xPos = 430;
          if (round == 3 || round == 4) xPos = 375;
          if (round == 5 || round == 6) xPos = 365;

          if (round == 1) yPos += 45;
          if (round == 2) yPos += 35;
          if (round == 3 || round == 4) yPos += 37;
          if (round == 5) yPos += 32;
          if (round == 6) yPos += 25;
        }
      });
    });
  }

  imageStore() {
    let tt = rowPos;
    finalImage = [];
    if (
      (round == 5 && wrong != 51) ||
      (round == 6 && (wrong != 32 || wrong != 48 || wrong != 64 || wrong != 96))
    ) {
      for (let i = colPos; i < col; i++) {
        if (i == colPos) tt = rowPos;
        else tt = 0;
        for (let j = tt; j < row; j++) finalImage.push(imageSet[j][i]);
      }
    }
    if (
      (round == 5 && wrong == 51) ||
      (round == 6 && (wrong == 32 || wrong == 48 || wrong == 64 || wrong == 96))
    ) {
      for (let i = 0; i < col; i++) {
        for (let j = 0; j < row; j++) finalImage.push(imageSet[j][i]);
      }
    }
  }

  wrongGroupMove(container, distance) {
    this.tweens.add({
      targets: container,
      x: distance,
      duration: 500,
      delay: 50,
      ease: 'Power1',
      yoyo: false,
    });
  }

  // Replacement for rex shake plugin: tween x position with high frequency.
  _shakeContainer(container, magnitude = 3, duration = 2500) {
    const startX = container.x;
    const tween = this.tweens.add({
      targets: container,
      x: startX + magnitude,
      duration: 30,
      yoyo: true,
      repeat: Math.floor(duration / 60),
      onComplete: () => {
        container.x = startX;
      },
    });
    return tween;
  }

  wrongEffect() {
    this.incorrectAnswers.setVolume(0.5).play();

    this.input1.setTexture('wrong');
    this.input2.setTexture('wrong');
    this.inputTextTenth.setFill('#C22300');
    this.inputTextUnit.setFill('#C22300');
    this.input.keyboard.enabled = false;
    this.input1.disableInteractive();
    this.input2.disableInteractive();
    this.confirm.disableInteractive();
    wrongEffect = 1;

    if (round == 1 && groupCount < 2) this.shakeEffect(this.container9, 'redBlue');
    else if (round == 1 && groupCount < 3) this.shakeEffect(this.container10, 'redBlue');
    else if (round == 1 && groupCount >= 3) this.shakeEffect(this.container11, 'redBlue');

    if (round == 2 && groupCount < 2) this.shakeEffect(this.container9, 'redPurple');
    else if (round == 2 && groupCount < 3 && wrong != 36)
      this.shakeEffect(this.container10, 'redPurple');
    else if (round == 2 && groupCount < 4 && wrong != 24 && wrong != 36)
      this.shakeEffect(this.container11, 'redPurple');
    else if (round == 2 && groupCount >= 4)
      this.shakeEffect(this.container12, 'redPurple');
    else if (round == 2 && (wrong == 24 || wrong == 36)) {
      this.shakeEffect(this.container9, 'redPurple');
      this.shakeEffect(this.container10, 'redPurple');
      this.shakeEffect(this.container11, 'redPurple');
    }

    if (round == 3 && groupCount < 2) this.shakeEffect(this.container9, 'redYellow');
    else if (round == 3 && groupCount < 3 && wrong != 54)
      this.shakeEffect(this.container10, 'redYellow');
    else if (round == 3 && groupCount < 4 && wrong != 36 && wrong != 54)
      this.shakeEffect(this.container11, 'redYellow');
    else if (round == 3 && groupCount < 5 && wrong != 27 && wrong != 36 && wrong != 54)
      this.shakeEffect(this.container12, 'redYellow');
    else if (round == 3 && groupCount < 6 && wrong != 27 && wrong != 36 && wrong != 54)
      this.shakeEffect(this.container13, 'redYellow');
    else if (round == 3 && groupCount >= 6)
      this.shakeEffect(this.container14, 'redYellow');
    else if (round == 3 && (wrong == 27 || wrong == 36 || wrong == 54)) {
      this.shakeEffect(this.container9, 'redYellow');
      this.shakeEffect(this.container10, 'redYellow');
      this.shakeEffect(this.container11, 'redYellow');
      this.shakeEffect(this.container12, 'redYellow');
    }

    if (round == 4 && groupCount < 2) this.shakeEffect(this.container9, 'redGreen');
    else if (round == 4 && groupCount < 3 && wrong != 56)
      this.shakeEffect(this.container10, 'redGreen');
    else if (round == 4 && groupCount < 4 && wrong != 56)
      this.shakeEffect(this.container11, 'redGreen');
    else if (round == 4 && groupCount < 5 && wrong != 28 && wrong != 56)
      this.shakeEffect(this.container12, 'redGreen');
    else if (round == 4 && groupCount < 6 && wrong != 28 && wrong != 56)
      this.shakeEffect(this.container13, 'redGreen');
    else if (round == 4 && groupCount < 7 && wrong != 28 && wrong != 56)
      this.shakeEffect(this.container14, 'redGreen');
    else if (round == 4 && groupCount < 8 && wrong != 16 && wrong != 28 && wrong != 56)
      this.shakeEffect(this.container15, 'redGreen');
    else if (round == 4 && groupCount >= 8)
      this.shakeEffect(this.container16, 'redGreen');
    else if (round == 4 && (wrong == 16 || wrong == 28 || wrong == 56)) {
      this.shakeEffect(this.container9, 'redGreen');
      this.shakeEffect(this.container10, 'redGreen');
      this.shakeEffect(this.container11, 'redGreen');
      this.shakeEffect(this.container12, 'redGreen');
      this.shakeEffect(this.container13, 'redGreen');
      this.shakeEffect(this.container14, 'redGreen');
      this.shakeEffect(this.container15, 'redGreen');
    }

    if (round == 5 && groupCount < 2) this.shakeEffect(this.container9, 'redPink');
    else if (round == 5 && groupCount < 3) this.shakeEffect(this.container10, 'redPink');
    else if (round == 5 && groupCount < 4 && wrong != 51)
      this.shakeEffect(this.container11, 'redPink');
    else if (round == 5 && groupCount < 5 && wrong != 51)
      this.shakeEffect(this.container12, 'redPink');
    else if (round == 5 && groupCount < 6 && wrong != 51)
      this.shakeEffect(this.container13, 'redPink');
    else if (round == 5 && groupCount < 7 && wrong != 51)
      this.shakeEffect(this.container14, 'redPink');
    else if (round == 5 && groupCount < 8 && wrong != 51)
      this.shakeEffect(this.container15, 'redPink');
    else if (round == 5 && groupCount < 9 && wrong != 51)
      this.shakeEffect(this.container16, 'redPink');
    else if (round == 5 && groupCount >= 9 && wrong != 51)
      this.shakeEffect(this.container17, 'redPink');
    else if (round == 5 && wrong == 51) {
      this.shakeEffect(this.container9, 'redPink');
      this.shakeEffect(this.container10, 'redPink');
      this.shakeEffect(this.container11, 'redPink');
    }

    if (round == 6 && groupCount < 2) this.shakeEffect(this.container9, 'redLightGreen');
    else if (round == 6 && groupCount < 3 && wrong != 96)
      this.shakeEffect(this.container10, 'redLightGreen');
    else if (round == 6 && groupCount < 4 && wrong != 64 && wrong != 96)
      this.shakeEffect(this.container11, 'redLightGreen');
    else if (round == 6 && groupCount < 5 && wrong != 48 && wrong != 64 && wrong != 96)
      this.shakeEffect(this.container12, 'redLightGreen');
    else if (round == 6 && groupCount < 6 && wrong != 48 && wrong != 64 && wrong != 96)
      this.shakeEffect(this.container13, 'redLightGreen');
    else if (
      round == 6 &&
      groupCount < 7 &&
      wrong != 32 &&
      wrong != 48 &&
      wrong != 64 &&
      wrong != 96
    )
      this.shakeEffect(this.container14, 'redLightGreen');
    else if (
      round == 6 &&
      groupCount < 8 &&
      wrong != 32 &&
      wrong != 48 &&
      wrong != 64 &&
      wrong != 96
    )
      this.shakeEffect(this.container15, 'redLightGreen');
    else if (round == 6 && groupCount >= 8)
      this.shakeEffect(this.container16, 'redLightGreen');
    else if (round == 6 && (wrong == 32 || wrong == 48 || wrong == 64 || wrong == 96)) {
      this.shakeEffect(this.container9, 'redLightGreen');
      this.shakeEffect(this.container10, 'redLightGreen');
      this.shakeEffect(this.container11, 'redLightGreen');
      this.shakeEffect(this.container12, 'redLightGreen');
      this.shakeEffect(this.container13, 'redLightGreen');
      this.shakeEffect(this.container14, 'redLightGreen');
    }

    this.time.delayedCall(3000, () => {
      this.input1.setTexture('default');
      this.input2.setTexture('default');
      this.inputTextUnit.text = '';
      this.inputTextTenth.text = '';
      this.input.keyboard.enabled = true;
      this.input1.setInteractive();
      this.input2.setInteractive();

      if (round == 1) {
        [this.container9, this.container10, this.container11].forEach(c =>
          c.each(child => child.setTexture('blue')),
        );
      }
      if (round == 2) {
        [this.container9, this.container10, this.container11, this.container12].forEach(
          c => c.each(child => child.setTexture('purple')),
        );
      }
      if (round == 3) {
        [
          this.container9,
          this.container10,
          this.container11,
          this.container12,
          this.container13,
          this.container14,
        ].forEach(c => c.each(child => child.setTexture('yellow')));
      }
      if (round == 4) {
        [
          this.container9,
          this.container10,
          this.container11,
          this.container12,
          this.container13,
          this.container14,
          this.container15,
          this.container16,
        ].forEach(c => c.each(child => child.setTexture('green')));
      }

      if (round >= 5) {
        let limit = 0;
        if (round == 5 && groupCount == 9) {
          this.container17.each(child => {
            child.setTexture(finalImage[limit]);
            limit++;
          });
        }
        if (groupCount == 8) {
          this.container16.each(child => {
            child.setTexture(finalImage[limit]);
            limit++;
          });
        }
        if (groupCount == 7) {
          this.container15.each(child => {
            child.setTexture(finalImage[limit]);
            limit++;
          });
        }
        if (groupCount == 6) {
          if (round == 6 && wrong == 32) {
            [
              this.container9,
              this.container10,
              this.container11,
              this.container12,
              this.container13,
            ].forEach(c =>
              c.each(child => {
                child.setTexture(finalImage[limit]);
                limit++;
              }),
            );
          }
          this.container14.each(child => {
            child.setTexture(finalImage[limit]);
            limit++;
          });
        }
        if (groupCount == 5) {
          this.container13.each(child => {
            child.setTexture(finalImage[limit]);
            limit++;
          });
        }
        if (groupCount == 4) {
          if (round == 6 && wrong == 48) {
            [this.container9, this.container10, this.container11].forEach(c =>
              c.each(child => {
                child.setTexture(finalImage[limit]);
                limit++;
              }),
            );
          }
          this.container12.each(child => {
            child.setTexture(finalImage[limit]);
            limit++;
          });
        }
        if (groupCount == 3) {
          if ((round == 5 && wrong == 51) || (round == 6 && wrong == 64)) {
            [this.container9, this.container10].forEach(c =>
              c.each(child => {
                child.setTexture(finalImage[limit]);
                limit++;
              }),
            );
          }
          this.container11.each(child => {
            child.setTexture(finalImage[limit]);
            limit++;
          });
        }
        if (groupCount == 2) {
          if (round == 6 && wrong == 96) {
            this.container9.each(child => {
              child.setTexture(finalImage[limit]);
              limit++;
            });
          }
          this.container10.each(child => {
            child.setTexture(finalImage[limit]);
            limit++;
          });
        }
        if (groupCount == 1) {
          this.container9.each(child => {
            child.setTexture(finalImage[limit]);
            limit++;
          });
        }
      }
    });
  }

  shakeEffect(container, image) {
    container.each(child => child.setTexture(image));
    this._shakeContainer(container, 3, 2500);
  }

  correctEffects() {
    this.correctAnswers.setVolume(0.5).play();
    this.confetti = this.add
      .sprite(665, -50, 'confetti')
      .setDepth(1)
      .setScale(0.8)
      .play('confetti');
    this.confirm.setDepth(2);
    this.input1.setTexture('correct');
    this.input2.setTexture('correct');
    this.inputTextTenth.setFill('#228B22');
    this.inputTextUnit.setFill('#228B22');
    this.cursorTenth.setAlpha(0);
    this.cursorUnit.setAlpha(0);
    this.input.keyboard.enabled = false;
    this.input1.disableInteractive();
    this.input2.disableInteractive();
    this.confirm.disableInteractive();
    correctEffect = 1;

    this.tweens.add({
      targets: this.confirm,
      alpha: 0,
      scale: 0,
      duration: 300,
      delay: 50,
      ease: 'Power1',
      yoyo: false,
    });

    this.time.delayedCall(1500, () => {
      this.containerNotepad = this.add.container(0, 0, [
        this.pencil,
        this.notepad,
        this.dividendHundredth,
        this.dividendTenth,
        this.dividendUnit,
        this.divisor,
        this.input1,
        this.input2,
        this.cursorTenth,
        this.cursorUnit,
        this.inputTextTenth,
        this.inputTextUnit,
      ]);

      this.tweens.add({
        targets: this.containerNotepad,
        x: 1100,
        duration: 500,
        delay: 50,
        ease: 'Power1',
        yoyo: false,
      });

      if (round == 1) {
        this.correctGroupMove(this.container1, -70);
        this.correctGroupMove(this.container2, 0);
        this.correctGroupMove(this.container3, 70);
      }
      if (round == 2) {
        this.correctGroupMove(this.container1, -100);
        this.correctGroupMove(this.container2, -50);
        this.correctGroupMove(this.container3, 0);
        this.correctGroupMove(this.container4, 50);
      }
      if (round == 3) {
        this.correctGroupMove(this.container1, -150);
        this.correctGroupMove(this.container2, -100);
        this.correctGroupMove(this.container3, -50);
        this.correctGroupMove(this.container4, 0);
        this.correctGroupMove(this.container5, 50);
        this.correctGroupMove(this.container6, 100);
      }
      if (round == 4 || round == 6) {
        this.correctGroupMove(this.container1, -160);
        this.correctGroupMove(this.container2, -120);
        this.correctGroupMove(this.container3, -80);
        this.correctGroupMove(this.container4, -40);
        this.correctGroupMove(this.container5, 0);
        this.correctGroupMove(this.container6, 40);
        this.correctGroupMove(this.container7, 80);
        this.correctGroupMove(this.container8, 120);
      }
      if (round == 5) {
        this.correctGroupMove(this.container1, -200);
        this.correctGroupMove(this.container2, -150);
        this.correctGroupMove(this.container3, -100);
        this.correctGroupMove(this.container4, -50);
        this.correctGroupMove(this.container5, 0);
        this.correctGroupMove(this.container6, 50);
        this.correctGroupMove(this.container7, 100);
        this.correctGroupMove(this.container8, 150);
        this.correctGroupMove(this.container9, 200);
      }

      this.time.delayedCall(2000, () => {
        if (round == 1) {
          this.snackAccumulation(accumulator1, 380, 430, 390, 450);
          this.snackAccumulation(accumulator2, 460, 520, 630, 680);
          this.snackAccumulation(accumulator3, 380, 430, 830, 880);
        }
        if (round == 2) {
          this.snackAccumulation(accumulator1, 350, 400, 330, 370);
          this.snackAccumulation(accumulator2, 480, 530, 540, 590);
          this.snackAccumulation(accumulator3, 470, 520, 770, 830);
          this.snackAccumulation(accumulator4, 350, 400, 960, 1000);
        }
        if (round == 3) {
          this.snackAccumulation(accumulator1, 200, 250, 515, 570);
          this.snackAccumulation(accumulator2, 200, 250, 670, 730);
          this.snackAccumulation(accumulator3, 200, 250, 850, 900);
          this.snackAccumulation(accumulator4, 400, 450, 525, 580);
          this.snackAccumulation(accumulator5, 400, 450, 670, 730);
          this.snackAccumulation(accumulator6, 400, 450, 840, 890);
        }
        if (round == 4 || round == 6) {
          this.snackAccumulation(accumulator1, 160, 210, 480, 530);
          this.snackAccumulation(accumulator2, 400, 450, 460, 500);
          this.snackAccumulation(accumulator3, 250, 300, 600, 660);
          this.snackAccumulation(accumulator4, 450, 500, 560, 600);
          this.snackAccumulation(accumulator5, 160, 210, 720, 780);
          this.snackAccumulation(accumulator6, 400, 450, 680, 740);
          this.snackAccumulation(accumulator7, 250, 300, 860, 910);
          this.snackAccumulation(accumulator8, 450, 500, 830, 880);
        }
        if (round == 5) {
          this.snackAccumulation(accumulator1, 310, 360, 370, 430);
          this.snackAccumulation(accumulator2, 160, 210, 500, 550);
          this.snackAccumulation(accumulator3, 400, 450, 450, 500);
          this.snackAccumulation(accumulator4, 250, 300, 620, 670);
          this.snackAccumulation(accumulator5, 450, 500, 550, 610);
          this.snackAccumulation(accumulator6, 160, 210, 710, 760);
          this.snackAccumulation(accumulator7, 400, 450, 640, 710);
          this.snackAccumulation(accumulator8, 250, 300, 830, 880);
          this.snackAccumulation(accumulator9, 450, 500, 780, 830);
        }
      });
    });
  }

  correctGroupMove(container, displacement) {
    this.tweens.add({
      targets: container,
      x: displacement,
      duration: 500,
      delay: 50,
      ease: 'Power1',
      yoyo: false,
    });
  }

  snackAccumulation(accum, min1, max1, min2, max2) {
    call++;
    let down = Phaser.Math.Between(min1, max1);
    let side = Phaser.Math.Between(min2, max2);
    this.candiesGrouping.setVolume(0.5).play();
    for (let i = 0; i < accum.length; i++) {
      this.tweens.add({
        targets: accum[i],
        y: down,
        duration: 1000,
        delay: 25,
        ease: 'Power1',
        yoyo: false,
      });
      this.tweens.add({
        targets: accum[i],
        x: side,
        duration: 1000,
        delay: 25,
        ease: 'Power1',
        yoyo: false,
      });
      down = Phaser.Math.Between(min1, max1);
      side = Phaser.Math.Between(min2, max2);
    }

    if (
      (round == 1 && call >= 3) ||
      (round == 2 && call >= 4) ||
      (round == 3 && call >= 6) ||
      ((round == 4 || round == 6) && call >= 8) ||
      (round == 5 && call >= 9)
    ) {
      this.time.delayedCall(900, () => {
        if (round == 1) {
          this.plateCreation(350, 420, this.container1, accumulator1);
          this.accumulatorOut1 = this.add.container(0, 0, [this.plate, this.container1]);
          this.time.delayedCall(250, () => {
            this.plateCreation(650, 500, this.container2, accumulator2);
            this.accumulatorOut2 = this.add.container(0, 0, [
              this.plate,
              this.container2,
            ]);
          });
          this.time.delayedCall(450, () => {
            this.plateCreation(930, 420, this.container3, accumulator3);
            this.accumulatorOut3 = this.add.container(0, 0, [
              this.plate,
              this.container3,
            ]);
          });
        }
        if (round == 2) {
          this.plateCreation(250, 385, this.container1, accumulator1);
          this.accumulatorOut1 = this.add.container(0, 0, [this.plate, this.container1]);
          this.time.delayedCall(250, () => {
            this.plateCreation(510, 510, this.container2, accumulator2);
            this.accumulatorOut2 = this.add.container(0, 0, [
              this.plate,
              this.container2,
            ]);
          });
          this.time.delayedCall(450, () => {
            this.plateCreation(800, 510, this.container3, accumulator3);
            this.accumulatorOut3 = this.add.container(0, 0, [
              this.plate,
              this.container3,
            ]);
          });
          this.time.delayedCall(650, () => {
            this.plateCreation(1030, 385, this.container4, accumulator4);
            this.accumulatorOut4 = this.add.container(0, 0, [
              this.plate,
              this.container4,
            ]);
          });
        }
        if (round == 3) {
          this.plateCreation(400, 230, this.container1, accumulator1);
          this.accumulatorOut1 = this.add.container(0, 0, [this.plate, this.container1]);
          this.time.delayedCall(250, () => {
            this.plateCreation(600, 230, this.container2, accumulator2);
            this.accumulatorOut2 = this.add.container(0, 0, [
              this.plate,
              this.container2,
            ]);
          });
          this.time.delayedCall(450, () => {
            this.plateCreation(830, 230, this.container3, accumulator3);
            this.accumulatorOut3 = this.add.container(0, 0, [
              this.plate,
              this.container3,
            ]);
          });
          this.time.delayedCall(650, () => {
            this.plateCreation(550, 430, this.container4, accumulator4);
            this.accumulatorOut4 = this.add.container(0, 0, [
              this.plate,
              this.container4,
            ]);
          });
          this.time.delayedCall(850, () => {
            this.plateCreation(750, 430, this.container5, accumulator5);
            this.accumulatorOut5 = this.add.container(0, 0, [
              this.plate,
              this.container5,
            ]);
          });
          this.time.delayedCall(1050, () => {
            this.plateCreation(950, 430, this.container6, accumulator6);
            this.accumulatorOut6 = this.add.container(0, 0, [
              this.plate,
              this.container6,
            ]);
          });
        }
        if (round == 4 || round == 6) {
          this.plateCreation(350, 200, this.container1, accumulator1);
          this.accumulatorOut1 = this.add.container(0, 0, [this.plate, this.container1]);
          this.time.delayedCall(250, () => {
            this.plateCreation(350, 440, this.container2, accumulator2);
            this.accumulatorOut2 = this.add.container(0, 0, [
              this.plate,
              this.container2,
            ]);
          });
          this.time.delayedCall(450, () => {
            this.plateCreation(550, 280, this.container3, accumulator3);
            this.accumulatorOut3 = this.add.container(0, 0, [
              this.plate,
              this.container3,
            ]);
          });
          this.time.delayedCall(650, () => {
            this.plateCreation(550, 490, this.container4, accumulator4);
            this.accumulatorOut4 = this.add.container(0, 0, [
              this.plate,
              this.container4,
            ]);
          });
          this.time.delayedCall(850, () => {
            this.plateCreation(750, 200, this.container5, accumulator5);
            this.accumulatorOut5 = this.add.container(0, 0, [
              this.plate,
              this.container5,
            ]);
          });
          this.time.delayedCall(1050, () => {
            this.plateCreation(750, 440, this.container6, accumulator6);
            this.accumulatorOut6 = this.add.container(0, 0, [
              this.plate,
              this.container6,
            ]);
          });
          this.time.delayedCall(1300, () => {
            this.plateCreation(970, 280, this.container7, accumulator7);
            this.accumulatorOut7 = this.add.container(0, 0, [
              this.plate,
              this.container7,
            ]);
          });
          this.time.delayedCall(1550, () => {
            this.plateCreation(970, 490, this.container8, accumulator8);
            this.accumulatorOut8 = this.add.container(0, 0, [
              this.plate,
              this.container8,
            ]);
          });
        }
        if (round == 5) {
          this.plateCreation(200, 340, this.container1, accumulator1);
          this.accumulatorOut1 = this.add.container(0, 0, [this.plate, this.container1]);
          this.time.delayedCall(250, () => {
            this.plateCreation(380, 200, this.container2, accumulator2);
            this.accumulatorOut2 = this.add.container(0, 0, [
              this.plate,
              this.container2,
            ]);
          });
          this.time.delayedCall(450, () => {
            this.plateCreation(380, 440, this.container3, accumulator3);
            this.accumulatorOut3 = this.add.container(0, 0, [
              this.plate,
              this.container3,
            ]);
          });
          this.time.delayedCall(650, () => {
            this.plateCreation(580, 280, this.container4, accumulator4);
            this.accumulatorOut4 = this.add.container(0, 0, [
              this.plate,
              this.container4,
            ]);
          });
          this.time.delayedCall(850, () => {
            this.plateCreation(580, 490, this.container5, accumulator5);
            this.accumulatorOut5 = this.add.container(0, 0, [
              this.plate,
              this.container5,
            ]);
          });
          this.time.delayedCall(1050, () => {
            this.plateCreation(780, 200, this.container6, accumulator6);
            this.accumulatorOut6 = this.add.container(0, 0, [
              this.plate,
              this.container6,
            ]);
          });
          this.time.delayedCall(1250, () => {
            this.plateCreation(780, 440, this.container7, accumulator7);
            this.accumulatorOut7 = this.add.container(0, 0, [
              this.plate,
              this.container7,
            ]);
          });
          this.time.delayedCall(1450, () => {
            this.plateCreation(1000, 280, this.container8, accumulator8);
            this.accumulatorOut8 = this.add.container(0, 0, [
              this.plate,
              this.container8,
            ]);
          });
          this.time.delayedCall(1650, () => {
            this.plateCreation(1000, 490, this.container9, accumulator9);
            this.accumulatorOut9 = this.add.container(0, 0, [
              this.plate,
              this.container9,
            ]);
          });
        }
      });
    }
  }

  plateCreation(plateX, plateY, container, accumulator) {
    this.bowlappear.setVolume(0.5).play();
    this.plate = this.add.image(plateX, plateY, 'plate').setScale(0.8).setDepth(1);
    container.setDepth(2);
    this.accumulatorEffect(accumulator, this.plate);
  }

  accumulatorEffect(accumulator, plate) {
    this.bigTween = this.tweens.add({
      targets: plate,
      scale: 0.9,
      duration: 200,
      delay: 10,
      repeat: 0,
      ease: 'Power1',
      yoyo: false,
    });

    this.bigTween.on('complete', () => {
      this.tweens.add({
        targets: plate,
        scale: 0.8,
        duration: 200,
        delay: 10,
        repeat: 0,
        ease: 'Power1',
        yoyo: false,
      });
    });

    if (round == 1 || round == 2 || round == 3) {
      this.scaling = this.tweens.add({
        targets: accumulator,
        scale: 1.3,
        duration: 250,
        delay: 50,
        ease: 'Power1',
        repeat: 0,
        yoyo: false,
      });
    }
    if (round == 4 || round == 5 || round == 6) {
      this.scaling = this.tweens.add({
        targets: accumulator,
        scale: 1.2,
        duration: 250,
        delay: 50,
        ease: 'Power1',
        repeat: 0,
        yoyo: false,
      });
    }

    this.scaling.on('complete', () => {
      if (round <= 3) {
        this.tweens.add({
          targets: accumulator,
          scale: 1.0,
          duration: 0,
          delay: 0,
          ease: 'Power1',
          repeat: 0,
          yoyo: false,
        });
      }
      if (round == 4 || round == 5) {
        this.tweens.add({
          targets: accumulator,
          scale: 1.1,
          duration: 0,
          delay: 0,
          ease: 'Power1',
          repeat: 0,
          yoyo: false,
        });
      }
      if (round == 6) {
        this.tweens.add({
          targets: accumulator,
          scale: 1.0,
          duration: 0,
          delay: 0,
          ease: 'Power1',
          repeat: 0,
          yoyo: false,
        });
      }
    });

    tick += 1;
    if (
      (tick == 3 && round == 1) ||
      (tick == 4 && round == 2) ||
      (tick == 6 && round == 3) ||
      (tick == 8 && (round == 4 || round == 6)) ||
      (tick == 9 && round == 5)
    ) {
      if (round == 1) this.tickAppear(52, this.smallBlue);
      if (round == 2) this.tickAppear(102, this.smallPurple);
      if (round == 3) this.tickAppear(153, this.smallYellow);
      if (round == 4) this.tickAppear(205, this.smallGreen);
      if (round == 5) this.tickAppear(255, this.smallPink);
      if (round == 6) this.tickAppear(307, this.smallGreen2);

      this.tick.on(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
        if (round <= 2) {
          this.accumulatorGroupOut(this.accumulatorOut1, -1000, 900);
          this.accumulatorGroupOut(this.accumulatorOut2, this.accumulatorOut2.x, 900);
          this.accumulatorGroupOut(this.accumulatorOut3, 1500, 900);
          this.accumulatorGroupOut(this.accumulatorOut4, 2000, 900);
        }
        if (round == 3) {
          this.accumulatorGroupOut(this.accumulatorOut1, -1000, -500);
          this.accumulatorGroupOut(this.accumulatorOut2, -800, -500);
          this.accumulatorGroupOut(this.accumulatorOut3, -600, -500);
          this.accumulatorGroupOut(this.accumulatorOut4, 600, 900);
          this.accumulatorGroupOut(this.accumulatorOut5, 800, 900);
          this.accumulatorGroupOut(this.accumulatorOut6, 1000, 900);
        }
        if (round == 4 || round == 6) {
          this.accumulatorGroupOut(this.accumulatorOut1, -1400, -900);
          this.accumulatorGroupOut(this.accumulatorOut2, -1200, -900);
          this.accumulatorGroupOut(this.accumulatorOut3, -1000, -900);
          this.accumulatorGroupOut(this.accumulatorOut4, -800, -900);
          this.accumulatorGroupOut(this.accumulatorOut5, 800, 900);
          this.accumulatorGroupOut(this.accumulatorOut6, 1000, 900);
          this.accumulatorGroupOut(this.accumulatorOut7, 1200, 900);
          this.accumulatorGroupOut(this.accumulatorOut8, 1400, 900);
        }
        if (round == 5) {
          this.accumulatorGroupOut(this.accumulatorOut1, -1600, -1200);
          this.accumulatorGroupOut(this.accumulatorOut2, -1400, -1200);
          this.accumulatorGroupOut(this.accumulatorOut3, -1200, -1200);
          this.accumulatorGroupOut(this.accumulatorOut4, -1000, -1200);
          this.accumulatorGroupOut(this.accumulatorOut5, -800, -1200);
          this.accumulatorGroupOut(this.accumulatorOut6, 1000, 1200);
          this.accumulatorGroupOut(this.accumulatorOut7, 1200, 1200);
          this.accumulatorGroupOut(this.accumulatorOut8, 1400, 1200);
          this.accumulatorGroupOut(this.accumulatorOut9, 1400, 1200);
        }

        this.time.delayedCall(1000, () => {
          round++;
          if (round <= 6) this.next();
          if (round > 6) {
            this.barContainer.destroy();
            for (let i = 0; i < tickStore.length; i++) tickStore[i].destroy();

            this.cameras.main.fadeOut(600, 0, 0, 0);
            this.cameras.main.once('camerafadeoutcomplete', () => {
              this.scene.start('EndScene');
            });
          }
        });
      });
    }
  }

  tickAppear(yPx, _image) {
    this.tick = this.add.sprite(57, yPx, 'tick').setDepth(3).setScale(0.08).play('tick');
    tickStore.push(this.tick);
    if (round == 1) {
      this.shadow1 = this.add.image(56, 54, 'shadow').setScale(1.04);
      this.barContainer.add(this.shadow1);
    }
    if (round == 2) {
      this.shadow2 = this.add.image(56, 104, 'shadow').setScale(1.04);
      this.barContainer.add(this.shadow2);
    }
    if (round == 3) {
      this.shadow3 = this.add.image(56, 155, 'shadow').setScale(1.04);
      this.barContainer.add(this.shadow3);
    }
    if (round == 4) {
      this.shadow4 = this.add.image(56, 205, 'shadow').setScale(1.04);
      this.barContainer.add(this.shadow4);
    }
    if (round == 5) {
      this.shadow5 = this.add.image(56, 256, 'shadow').setScale(1.04);
      this.barContainer.add(this.shadow5);
    }
    if (round == 6) {
      this.shadow6 = this.add.image(56, 307, 'shadow').setScale(1.04);
      this.barContainer.add(this.shadow6);
    }
    this.barContainer.setDepth(2);
  }

  accumulatorGroupOut(accumulator, xPx, yPx) {
    this.tweens.add({
      targets: accumulator,
      x: xPx,
      y: yPx,
      duration: 1500,
      delay: 50,
      ease: 'Power1',
      repeat: 0,
      yoyo: false,
    });
  }

  next() {
    firstInput = false;
    call = 0;
    tick = 0;
    if (round == 2) {
      poppins = [[], [], [], [], [], [], [], [], []];
      row = 9;
      col = 8;
      this.gridCreation(row, col, 'purple');
    }
    if (round == 3) {
      poppins = [[], [], [], [], [], [], [], [], []];
      row = 9;
      col = 12;
      this.gridCreation(row, col, 'yellow');
    }
    if (round == 4) {
      poppins = [[], [], [], [], [], [], []];
      row = 7;
      col = 16;
      this.gridCreation(row, col, 'green');
    }
    if (round == 5) {
      poppins = [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []];
      imageSet = [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []];
      row = 9;
      col = 17;
      this.gridCreation(row, col, 'pink');
    }
    if (round == 6) {
      poppins = [[], [], [], [], [], [], [], [], [], [], [], []];
      imageSet = [[], [], [], [], [], [], [], [], [], [], [], []];
      row = 12;
      col = 16;
      this.gridCreation(row, col, 'lightGreen');
    }
  }

  gridCreation(rArg, cArg, image) {
    delaying = 50;
    if (round == 2) {
      xPos = 430;
      yPos = 280;
    }
    if (round == 3) {
      xPos = 375;
      yPos = 270;
    }
    if (round == 4) {
      xPos = 375;
      yPos = 310;
    }
    if (round == 5) {
      xPos = 365;
      yPos = 290;
    }
    if (round == 6) {
      xPos = 365;
      yPos = 290;
    }

    for (let i = 0; i < rArg; i++) {
      for (let j = 0; j < cArg; j++) {
        if (round >= 5) imageSet[i][j] = image;
        poppins[i][j] = this.add.image(xPos, yPos, image).setScale(0);
        if (round == 2) xPos += 55;
        if (round == 3) xPos += 53;
        if (round == 4) xPos += 38;
        if (round == 5) xPos += 37;
        if (round == 6) xPos += 37;
      }
      if (round == 2) xPos = 430;
      if (round == 3 || round == 4) xPos = 375;
      if (round == 5 || round == 6) xPos = 365;

      if (round == 2) yPos += 35;
      if (round == 3 || round == 4) yPos += 37;
      if (round == 5) yPos += 32;
      if (round == 6) yPos += 25;
    }

    this.time.delayedCall(400, () => {
      this.candiesAppear.setVolume(0.1).play();

      for (let i = 0; i < rArg; i++) {
        this.candiesAppear.setVolume(0.1).play();
        this.scales = this.tweens.add({
          targets: poppins[i],
          scale: 1.1,
          duration: 350,
          delay: delaying,
          ease: 'Power1',
          repeat: 0,
          yoyo: false,
        });

        if (round <= 3) {
          this.scales.on('complete', () => {
            this.tweens.add({
              targets: poppins[i],
              scale: 1.0,
              duration: 0,
              delay: 0,
              ease: 'Power1',
              repeat: 0,
              yoyo: false,
            });
          });
        }
        if (round >= 4) {
          if (round == 4 || round == 5) {
            this.scales.on('complete', () => {
              this.tweens.add({
                targets: poppins[i],
                scale: 0.9,
                duration: 0,
                delay: 0,
                ease: 'Power1',
                repeat: 0,
                yoyo: false,
              });
            });
          }
          if (round == 6) {
            this.scales.on('complete', () => {
              this.tweens.add({
                targets: poppins[i],
                scale: 0.8,
                duration: 0,
                delay: 0,
                ease: 'Power1',
                repeat: 0,
                yoyo: false,
              });
            });
          }
        }
        delaying += 100;
      }
    });

    this.time.delayedCall(1300, () => {
      this.input1.setTexture('default');
      this.input2.setTexture('default');
      this.inputTextUnit.text = '';
      this.inputTextTenth.text = '';
      this.dividendTenth.setAlpha(0);
      this.dividendUnit.setAlpha(0);
      this.dividendHundredth.setAlpha(0);

      if (round == 2) {
        this.dividendTenth.text = '7';
        this.dividendUnit.text = '2';
        this.divisor.text = '4';
      }
      if (round == 3) {
        this.dividendHundredth.text = '1';
        this.dividendTenth.text = '0';
        this.dividendUnit.text = '8';
        this.divisor.text = '6';
      }
      if (round == 4) {
        this.dividendHundredth.text = '1';
        this.dividendTenth.text = '1';
        this.dividendUnit.text = '2';
        this.divisor.text = '8';
      }
      if (round == 5) {
        this.dividendHundredth.text = '1';
        this.dividendTenth.text = '5';
        this.dividendUnit.text = '3';
        this.divisor.text = '9';
      }
      if (round == 6) {
        this.dividendHundredth.text = '1';
        this.dividendTenth.text = '9';
        this.dividendUnit.text = '2';
        this.divisor.text = '8';
      }
      this.divisor.setAlpha(0);
      this.input.keyboard.enabled = true;
      this.input1.setInteractive();
      this.input2.setInteractive();
      this.confirm.setScale(1);
      this.confirm.setAlpha(0);

      if (round == 3) {
        this.notepad.setTexture('notepad2');
        this.containerNotepad.add(this.dividendHundredth);
        this.input1.x = 643;
        this.input2.x = 702;
        this.dividendHundredth.setAlpha(0);
        this.dividendTenth.x += 20;
        this.dividendUnit.x += 15;
        this.divisor.x += 15;
        this.cursorTenth.x += 13;
        this.cursorUnit.x += 14;
      }
      if (round == 4) this.dividendTenth.x += 10;
      if (round == 5) this.dividendTenth.x -= 5;

      this.containerNotepad.setDepth(2);
      this.cursorTenth.setDepth(1);
      this.cursorUnit.setDepth(1);
      this.noteTween = this.tweens.add({
        targets: this.containerNotepad,
        x: 0,
        duration: 500,
        delay: 50,
        ease: 'Power1',
        yoyo: false,
      });
      this.noteTween.on('complete', () => {
        this.cursorTenth.setAlpha(0);
        this.cursorUnit.setAlpha(0);
      });

      this.time.delayedCall(500, () => {
        this.tweens.add({
          targets: [
            this.dividendHundredth,
            this.dividendTenth,
            this.dividendUnit,
            this.divisor,
          ],
          alpha: 1,
          duration: 250,
          delay: 25,
          ease: 'Power1',
          repeat: 0,
          yoyo: false,
        });
      });
    });
  }

  update() {
    if (!this.cursorTenth || !this.cursorUnit) return;
    if (this.inputTextTenth.text.length > 0 || entry == 2)
      this.cursorTenth.setVisible(false);
    if (this.inputTextUnit.text.length > 0 || entry == 1)
      this.cursorUnit.setVisible(false);
    if (wrongEffect == 1 || correctEffect == 1) {
      this.cursorTenth.setVisible(false);
      this.cursorUnit.setVisible(false);
    }
  }
}
